import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import {  KaspiSettingsDownload } from 'src/app/models';
import { ApiKaspiSettingsService, NotificationService, ValidatorsService } from 'src/app/services';
import { KaspiSettingsValidator } from '../kaspi-settings.validator';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.css']
})
export class DownloadComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  errorMessages: any;
  settings: KaspiSettingsDownload;
  loading: boolean;

  downloadForm: UntypedFormGroup = this.fb.group({
    id:          [null],
    url:         [null, this.validator.url],
    login:       [null],
    password:    [null],
  })

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private apiKaspiSettings: ApiKaspiSettingsService,
    private notification: NotificationService,
    private validator: KaspiSettingsValidator,
    private validatorService: ValidatorsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;
    
    this.onEdit();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  initForm(): void {

    if(this.settings != null){

      this.downloadForm.setValue({
        id:          this.settings.id ? this.settings.id : null,
        url:         this.settings.url,
        login:       this.settings.login,
        password:    this.settings.password,
      });
    }
  }


  /**
   * 
   */
  onEdit(): void {

    this.progressRef.start();
    
    this.subscriptions.add(
      this.apiKaspiSettings.downloadInfo().subscribe((response: any) => { console.log('[RESPONSE] getCredentialData: ', response);

        if(response != null){

          this.settings = response.result;
          console.log(this.settings);
          

          this.initForm();
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete(); 
      })
    );
  }


  /**
   * 
   */
  onSave(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(
      this.apiKaspiSettings.dowloadSave(this.downloadForm.value).subscribe((response: any) => { console.log('[RESPONSE] saveCredentialData: ', response);

        if(response != null){

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
        this.loading = false;
      },
      error => { 
        this.progressRef.complete(); 
        this.loading = false;
      })
    );
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.downloadForm.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.downloadForm.get(field));
  }

}
